module.exports = __webpack_public_path__ + "static/media/PWID-T-01.11ed0788.png";